import Vue from 'vue';
import Router from 'vue-router';
import staticRouter from '@/router/staticRouter';
import {  setStore } from "assets/commonjs/storage";
Vue.use(Router);


const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_PROFILE == 'test'?'/mobile/':'/',
  routes: staticRouter
});
router.afterEach(() => {
  window.scrollTo(0, 0)
});
router.beforeEach((to, from, next) => {
  
  //说明是新版本的咨询模块 app里面
  if(to.query.liveNewVersion != "" && 
  to.query.liveNewVersion != undefined 
  && to.query.liveNewVersion != null 
  ){
    setStore("liveappver",to.query.liveNewVersion)
  }
  if(to.query.noneheader == 1){
    setStore('noneheader','yes')
  }
  if(to.query.pattern){
    setStore("patternLabel",to.query.pattern)
  }
 
  next()
})

export default router
